import {useRouter} from 'next/router';
import type {availableLanguages} from 'locales/metas.json';

export const useIsLocale = (
	localesList: typeof availableLanguages,
): boolean => {
	const {locale} = useRouter();
	const formattedLocalesList = localesList.join('|').toLowerCase();
	return formattedLocalesList.includes(locale.toLowerCase());
};
